export const titleConstants = {
  rxNumber: "Rx Number",
  claimId: "Claim ID",
  paymentId: "Payment ID",
  daysSupply: "Days Supply",
  quantity: "Quantity",
  ncpdp: "NCPDP",
  dispenseDate: "Dispense Date",
  bin: "BIN",
  pcn: "PCN",
  awp: "AWP",
  ndc: "NDC",
  ingredientCostPaid: "Ingredient Cost Paid",
  totalReimbursed: "Total Reimbursed",
  dispenseFeePaid: "Dispense Fee Paid",
  cardholderId: "Cardholder ID",
  totalRevenue: "Total Revenue",
  transactionDate: "Transaction Date",
  adjudicatedAmount: "Adjudicated Amount",
  ingredientCostSubmitted: "Ingredient Cost Submitted",
  authCode: "Auth Code",
  payerRaPaid: "Payer RA Paid",
  reconciled: "Reconciled",
  copay: "Co Pay",
}